import styles from './partners.module.scss';

export type Partner = {
	category: string;
	link: string;
	src: string;
	src2: string;
	alt: string;
}

export type PartnersData = {
	allPartnerLink: string;
	allPartnerLinkText: string;
	logos: Partner[];
}

export type PartnersProps = {
	data?: PartnersData;
};

export function Partners({ data }: PartnersProps) {
	const primarySponsors =
		data?.logos?.filter((logo) => logo.category === 'Primary sponsor') || [];
	const globalPartners =
		data?.logos?.filter((logo) => logo.category === 'Global partner') || [];
	const regionalPartners =
		data?.logos?.filter((logo) => logo.category === 'Regional partner') || [];

	return (

		<div className={styles['partners']}>
			{primarySponsors?.length > 0 && (
				<div className={styles['primary-partners']}>
					<ul className={styles['primary-list']} aria-label="Primary Sponsors">
						{primarySponsors.map((logo, index) => (
							<li key={index}>
								<a href={logo.link}>
									<picture>
										<source
											srcSet={`${logo.src}?width=160&height=80`}
										/>
										<img
											src={logo.src}
											alt={logo.alt}
											width="160"
											height="80"
										/>
									</picture>
								</a>
							</li>
						))}
					</ul>
				</div>
			)}

			{(globalPartners.length > 0 || regionalPartners.length > 0) && (
				<div className={styles['secondary-partners']}>
					<ul
						className={`${styles['partner-list']} ${styles['partner-list--global']}`}
						aria-label="Global Partners"
					>
						{globalPartners.map((logo, index) => (
							<li key={index}>
								<a href={logo.link}>
									<picture>
										<source
											srcSet={`${logo.src}?width=120&height=60`}
										/>
										<img
											src={logo.src}
											alt={logo.alt}
											width="120"
											height="60"
										/>
									</picture>
								</a>
							</li>
						))}
					</ul>

					<ul
						className={`${styles['partner-list']} ${styles['partner-list--regional']}`}
						aria-label="Regional Partners"
					>
						{regionalPartners.map((logo, index) => (
							<li key={index}>
								<a href={logo.link}>
									<picture>
										<source
											srcSet={`${logo.src}?width=80&height=40`}
										/>

										<img
											src={logo.src}
											alt={logo.alt}
											width="80"
											height="40"
										/>
									</picture>
								</a>
							</li>
						))}
					</ul>
				</div>
			)}

			{data?.allPartnerLink && data?.allPartnerLinkText && (
				<div className={styles['view-all-wrapper']}>
					<a
						className={`cta-medium ${styles['view-all']}`}
						href={data.allPartnerLink}
					>
						{data.allPartnerLinkText}
					</a>
				</div>
			)}
		</div>
	);
}

export default Partners;